import { Fragment, Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import {
  AUDITOR_MODIFIABLE_PART_STATES,
  AuditRequest,
  ClubEnrollment,
  PartStatus,
} from "../../../model";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { ReduxState } from "../../../reducers";
import { connect } from "react-redux";

export interface AuditFormButtonsProps extends WithTranslation {
  partState: PartStatus;
  enrollment?: ClubEnrollment | null;
  auditRequest?: AuditRequest | null;
  isNotesOpen?: boolean;
  onSubmitClick(): any;
  onDraftClick(): any;
  onBackClick(): any;
}

class AuditFormButtons extends Component<AuditFormButtonsProps, any> {
  private windowHeight = 0;
  constructor(props: AuditFormButtonsProps) {
    super(props);
    this.state = {
      float: true,
    };
  }

  componentDidMount() {
    this.windowHeight = window.innerHeight;
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateWindowHeight);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateWindowHeight);
  }

  updateWindowHeight = () => {
    this.windowHeight = window.innerHeight;

    // In some cases, we have to adjust the float state after resizing
    this.handleScroll();
  };

  handleScroll = () => {
    const buttons = document.getElementById("auditformbuttons");
    const buttonsBottom = buttons ? buttons.getBoundingClientRect().bottom : 0;
    const float = buttonsBottom > this.windowHeight;

    if (this.state.float !== float) {
      this.setState({
        float,
      });
    }
  };

  // PartFormWrapper decides whether to use AuditFormButtons or ClubFormButtons
  // onClick handlers are also passed from there
  render() {
    const {
      auditRequest,
      partState,
      onBackClick,
      onDraftClick,
      onSubmitClick,
      t,
    } = this.props;
    const modifiableByAuditor = auditRequest
      ? auditRequest.modifiableByAuditor
      : false;
    const readOnly =
      !modifiableByAuditor ||
      !AUDITOR_MODIFIABLE_PART_STATES.includes(partState);
    const popoverSend = (
      <Popover id="popover-positioned-bottom">
        {t("popovers.auditSend")}
      </Popover>
    );
    const popoverDraft = (
      <Popover id="popover-positioned-bottom">
        {t("popovers.auditDraft")}
      </Popover>
    );
    return (
      <Fragment>
        {this.state.float && (
          <div
            className={
              this.props.isNotesOpen
                ? "buttons floatbuttons floatwidth"
                : "buttons floatbuttons"
            }
          >
            <div className="centergroup">
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="top"
                overlay={popoverSend}
              >
                <button
                  type="button"
                  className="btn btn-secondary btn-secondary-blue"
                  disabled={readOnly}
                  onClick={onSubmitClick}
                >
                  {t("auditFormButtons.sendComments")}
                </button>
              </OverlayTrigger>
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="top"
                overlay={popoverDraft}
              >
                <button
                  type="button"
                  disabled={readOnly}
                  className="btn btn-secondary btn-secondary-blue"
                  onClick={onDraftClick}
                >
                  {t("auditFormButtons.saveDraft")}
                </button>
              </OverlayTrigger>

              <button
                type="button"
                className="btn btn-secondary btn-secondary-blue"
                onClick={onBackClick}
              >
                {t("auditFormButtons.back")}
              </button>
            </div>
          </div>
        )}
        <div id="auditformbuttons" className="buttons">
          <div className="centergroup">
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="bottom"
              overlay={popoverSend}
            >
              <button
                type="button"
                className="btn btn-secondary btn-secondary-blue"
                disabled={readOnly}
                onClick={onSubmitClick}
              >
                {t("auditFormButtons.sendComments")}
              </button>
            </OverlayTrigger>
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="bottom"
              overlay={popoverDraft}
            >
              <button
                type="button"
                disabled={readOnly}
                className="btn btn-secondary btn-secondary-blue"
                onClick={onDraftClick}
              >
                {t("auditFormButtons.saveDraft")}
              </button>
            </OverlayTrigger>

            <button
              type="button"
              className="btn btn-secondary btn-secondary-blue"
              onClick={onBackClick}
            >
              {t("auditFormButtons.back")}
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

const linksTranslated = withTranslation("common")(AuditFormButtons);

const mapStateToProps = (state: ReduxState) => {
  return {
    isNotesOpen: state.path.isNotesOpen,
  };
};

export default connect(mapStateToProps)(linksTranslated);
